import React from 'react'

function Parking() {
  return (
    <div className='nav-margin'>Parking</div>
  )
}

export default Parking